import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Button } from '@ferris/react/components/button';
import { TrackingContext } from '@vrbo/react-event-tracking';
import WebUtils from 'epc-web-utils';
import TranslationUtil from '../../utils/TranslationUtil';
import { getLinks } from '../../utils/LocaleMap';

const getPropsFromState = (state) => {
    const {
        translations, fallbackTranslations, locale, siteName
    } = state.app;
    const translationUtil = new TranslationUtil(translations, fallbackTranslations);
    const getTranslation = (suffix, params) => translationUtil.getTranslation(`Vrbo.lyp.pmvalueprops.${suffix}`, params);
    return {
        title: getTranslation('title'),
        text: getTranslation('text'),
        label: getTranslation('button.label'),
        locale: locale.canonical,
        siteName
    };
};

export const PMValueProps = () => {
    const {
        title, text, label, locale, siteName
    } = useSelector(getPropsFromState);
    const { trigger } = useContext(TrackingContext);
    const pmLink = getLinks(locale, siteName).haPmLink;
    const handleCTAClick = () => {
        trigger('genericClick', {
            category: 'navigation',
            action: 'PMValueProps: learn-more'
        });
        WebUtils.redirectToURL(pmLink);
    };

    return (
        <div className="pm-value-props" data-wdio="pm-value-props">
            <div className="pm-value-props__main-content">
                <h1 className="pm-value-props__title">{title}</h1>
                <p className="pm-value-props__text">{text}</p>
                <Button
                    classes="pm-value-props__button"
                    htmlButtonType="button"
                    type="utility"
                    variant="utility-reversed"
                    data-wdio="pm-value-props-cta"
                    onClick={handleCTAClick}
                >
                    {label}
                </Button>
            </div>
        </div>
    );
};

PMValueProps.displayName = 'PMValueProps';
export default PMValueProps;
